angular.module('nv.routes.privacy-and-terms', ['ui.router', 'nv.routes.config']);
